<div id="relax-overlay" class="bottom-center-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font">
    Sit back and relax.<br />
    We'll summarize at the end.
  </p>
</div>
